const sector_charts = [
  {
    sector: "India",
    symbols: [
      {
        abs: "^CNXAUTO",
        rel: "^CNXAUTO/^NSEI",
      },
      {
        abs: "^NSEBANK",
        rel: "^NSEBANK/^NSEI",
      },
      {
        abs: "^CNXFMCG",
        rel: "^CNXFMCG/^NSEI",
      },
      {
        abs: "^CNXIT",
        rel: "^CNXIT/^NSEI",
      },
      {
        abs: "^CNXMEDIA",
        rel: "^CNXMEDIA/^NSEI",
      },
      {
        abs: "^CNXMETAL",
        rel: "^CNXMETAL/^NSEI",
      },
      {
        abs: "^CNXPHARMA",
        rel: "^CNXPHARMA/^NSEI",
      },
      {
        abs: "^CNXREALTY",
        rel: "^CNXREALTY/^NSEI",
      },
      {
        abs: "^CNXPSUBANK",
        rel: "^CNXPSUBANK/^NSEI",
      },
      {
        abs: "^CNXINFRA",
        rel: "^CNXINFRA/^NSEI",
      },
      {
        abs: "^CNXENERGY",
        rel: "^CNXENERGY/^NSEI",
      },
    ],
  },
];


export function getSectorCharts() {
    const dataPromise = new Promise((resolve, reject) => {
      // Simulating an asynchronous operation (e.g., fetching data from an API)
      setTimeout(() => {
        const dummyData = sector_charts;
        resolve(dummyData);
      }, 1000); // Simulating a 1-second delay, replace with your actual async operation time
    });
    return dataPromise;
  }
